__webpack_require__.p = "/static-apps/resource-catalogue/main/";